export const theme = {
  spaces: {
    sm: '4px',
    md: '8px',
  },
  shadow: {
    // base: `0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);`,
    base: `0 3px 6px -4px #0000001f, 0 6px 16px #00000014, 0 9px 28px 8px #0000000d`,
  },
  borderRadius: {
    md: '2px',
  },

  fontSize: {
    sm: '12px',
    smd: '14px',
    md: '16px',
  },
  transition: {
    default: 'all .3s',
  },

  color: {
    primary: '#0082c8',
    lightBg: '#f5f6f8',

    primaryLight: '#e0e9fd',
    border: '#E5E7EB',
    // borderLight: '#e0e3e8',
    borderLight: '#F3F4F6',
    veryLight: '#F9FAFB',

    blueVeryLight: '#EFF6FF',
    blueLight: '#DBEAFE',

    lightHighlight: '#D97706',
    yellowHighlight: '#FEF3C7',
    yellowLight: '#FFFBEB',

    danger: '#EF4444',
    success: '#10B981',

    text: 'rgb(85, 85, 85)',
    textOnPrimary: 'white',
    textOnDanger: 'white',
    textOnSuccess: 'white',
    textOnBorder: 'rgb(85, 85, 85)',
    textLight: 'rgba(125,125,125)',
  },

  zIndex: {
    modal: 99999,
  },
};

export type ITheme = typeof theme;

export { styles } from './helper';
